export const theme = {
  colors: {
    primary: {
      one: '#181A1B',
      two: '#434755',
      three: '#5678a6' // Need to change it to our main color in the future
    },
    secondary: {
      one: '#fff',
      two: '#1F2229',
    },
    text: {
      one: '#dad7d2',
      two: '#393939',
      three: '#848898',
    },
    white: '#fff',
    black: '#000',
  },
  breakpoints: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
  },
  spacing: {
    0: '0',
    1: '5px',
    2: '10px',
    3: '15px',
    4: '25px',
    5: '50px',
    6: '150px',
  },
  border: {
    radius: '8px',
  },
}
